import React from 'react';
import './About.css';

const About = () => {
  const partners = [
    {
      name: 'CS Pravesh Palood',
      role: 'Founding Partner',
      description: 'CS Pravesh Palood founder at Carmanya is also a practicing Company Secretary and has experience of more than 25 years in the field of corporate law. He is also the founder of Mangalam Placement Private Limited. After starting as a practicing company secretary, Atul Carmanya served as company secretary compliance head for 5 years. He is a secretary of the International Association of Company Secretaries comprising 42 global countries as its members.',
      linkedin: '#',
      facebook: '#'
    }
  ];

  const features = [
    {
      title: 'Expert and Specialised Professionals',
      description: 'We are a team of legal professionals having expertise and specialisation in various corporate fields such as Secretarial Compliance, Insolvency & Bankruptcy, CSR, Listing, Business Formation, Corporate Governance etc.'
    },
    {
      title: 'Legal Team',
      description: 'We have qualified professionals and legal experts partnering with us in various parts of the country. We have offices across the country with professional and skilled support staff taking care of services and clients.'
    },
    {
      title: 'Client-Centric Approach',
      description: 'We believe that with individual client comes responsibility of providing personalised solutions and services to every client individually. Hence, we are focused on providing personalised solutions to our clients based on their legal need.'
    }
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>About Carmanya</h1>
          <p>Practical Wisdom, Trusted Advice</p>
        </div>
      </section>

      <section className="section about-intro">
        <div className="container">
          <div className="intro-content">
            <h2>Who We Are</h2>
            <p>
              Carmanya Legal & Advisory Services is one of the prominent and largest 
              legal firms in India having branches spread across the country. We are known 
              for providing effective solutions and trusted advice with the help of team of 
              corporate legal experts.
            </p>
            <p>
              We are one of the largest corporate, legal and secretarial service providers. 
              Building strong and substantial client relationship is and will remain the 
              compass for our business strategy and future development.
            </p>
          </div>
        </div>
      </section>

      <section className="section founding-partners">
        <div className="container">
          <h2 className="section-title">Meet Our Founding Partners</h2>
          <div className="partners-grid">
            {partners.map((partner, index) => (
              <div key={index} className="partner-card">
                <div className="partner-header">
                  <h3>{partner.name}</h3>
                  <p className="partner-role">{partner.role}</p>
                </div>
                <p className="partner-description">{partner.description}</p>
                <div className="partner-social">
                  <a href={partner.linkedin} target="_blank" rel="noopener noreferrer">
                    LinkedIn
                  </a>
                  <a href={partner.facebook} target="_blank" rel="noopener noreferrer">
                    Facebook
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section why-choose-us">
        <div className="container">
          <h2 className="section-title">Why Choose Us?</h2>
          <p className="section-subtitle">
            We are well-known financial and company secretarial advisors with strong corporate presence in the 
            industry. Our highlighting features in the service sector industry give us a 
            competitive edge over other financial and company secretarial service providing firms.
          </p>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section locations">
        <div className="container">
          <h2 className="section-title">Our Presence</h2>
          <p className="locations-text">
            We are present across India with offices in: Mumbai, Navi Mumbai, Pune, Cochin, 
            Kolkata, Vapi, Aurangabad, Hyderabad, Ahmedabad, Delhi, Kolhapur, Bengaluru, 
            Jaipur, Raipur, and Bhubaneswar.
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;
